import { render, staticRenderFns } from "./InputCard.vue?vue&type=template&id=d60a97ac&scoped=true&"
import script from "./InputCard.vue?vue&type=script&lang=js&"
export * from "./InputCard.vue?vue&type=script&lang=js&"
import style0 from "./InputCard.vue?vue&type=style&index=0&id=d60a97ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60a97ac",
  null
  
)

export default component.exports
import {QForm,QInput,QIcon,QCardActions,QBtn,QSpinnerPuff,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QIcon,QCardActions,QBtn,QSpinnerPuff,QCard})
